import { useCallback, useState } from "react";
import { Link } from "react-router";

import { MigrationCard } from "@/components/MigrationCard";
import { StepBar } from "@/components/StepBar";
import { MigrateIcon, PermissionIcon } from "@/components/icons";
import { ContractBar } from "@/components/ui";
import { CLAIM_CONTRACT, NETWORK_NAME, explorerAddress } from "@/lib/config";
import { usePageMeta } from "@/lib/page-meta";

export function SwapPage() {
  usePageMeta({
    title: "Migrasi AsetQu Legacy",
    description:
      "Migrasikan AsetQu Legacy melalui dua transaksi yang dapat direview dan diverifikasi.",
  });

  /* The card owns the flow; the rail above the title only mirrors it. */
  const [step, setStep] = useState(1);
  const onStep = useCallback((next: number) => setStep(next), []);

  return (
    <div className="terminal">
      <header className="terminal-intro">
        <p className="terminal-eyebrow">
          <strong>Official migration</strong>
          <span aria-hidden>/</span>
          <span>{NETWORK_NAME}</span>
        </p>

        <StepBar current={step} />

        <p className="terminal-facts">
          <span>Rasio 1 : 1</span>
          <span>Exact approval</span>
          <span>Dua tanda tangan</span>
        </p>

        <h1>Migrasikan AsetQu Legacy</h1>
        <p className="terminal-lede">
          Satu keputusan per tahap. Periksa wallet, jumlah, network, dan kontrak penuh sebelum
          setiap tanda tangan.
        </p>
      </header>

      <MigrationCard onStep={onStep} />

      <section className="phase-cards" aria-label="Dua tahap tanda tangan">
        <article className="phase-card">
          <p className="phase-card__index">Tahap 1</p>
          <h3>
            <PermissionIcon size={18} /> Izin token
          </h3>
          <p>Exact amount. Belum memindahkan token.</p>
        </article>
        <article className="phase-card">
          <p className="phase-card__index">Tahap 2</p>
          <h3>
            <MigrateIcon size={18} /> Migrasi
          </h3>
          <p>Memindahkan token legacy dan menerima token baru.</p>
        </article>
      </section>

      <section className="signature-notes" aria-labelledby="signature-notes-title">
        <div className="signature-notes__lead">
          <p>Model dua tanda tangan</p>
          <h2 id="signature-notes-title">Izin token bukan perpindahan token.</h2>
        </div>
        <dl>
          <dt>01 / Permission</dt>
          <dd>
            Memberi kontrak migrasi izin menggunakan jumlah AsetQu Legacy yang Anda pilih. Tidak ada
            token yang berpindah pada tahap ini.
          </dd>
        </dl>
        <dl>
          <dt>02 / Migration</dt>
          <dd>
            Memindahkan AsetQu Legacy melalui kontrak resmi dan mengirim AsetQu baru ke wallet yang
            sama dengan rasio 1:1.
          </dd>
        </dl>
      </section>

      {CLAIM_CONTRACT ? (
        <ContractBar
          label="Official migration contract"
          address={CLAIM_CONTRACT}
          href={explorerAddress(CLAIM_CONTRACT)}
        />
      ) : null}

      <p className="terminal-footnote">
        Butuh pembanding alamat? Buka <Link to="/contract-addresses">daftar kontrak resmi</Link> atau
        baca <Link to="/security">aturan keamanan</Link> sebelum melanjutkan.
      </p>
    </div>
  );
}
